import React from "react";
import { Form, Input, Row, Col, Card, Typography, Button, Space } from "antd";
import { MessageOutlined, PlusOutlined, MinusCircleOutlined } from "@ant-design/icons";

const { Title } = Typography;
const { TextArea } = Input;

interface WelcomeTabProps {
  form: any;
}

export const WelcomeTab: React.FC<WelcomeTabProps> = ({ form }) => {
  return (
    <div>
      <Title level={4}>
        <MessageOutlined style={{ marginRight: '8px' }} />
        Willkommensbrief
      </Title>
      
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Card title="Persönliche Anrede" size="small">
            <Form.Item
              name={['content', 'welcomeLetter', 'salutation']}
              label="Anrede"
              rules={[{ required: true, message: 'Bitte geben Sie eine Anrede ein' }]}
            >
              <Input placeholder="z.B. Liebe Gäste," />
            </Form.Item>
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: '16px' }}>
        <Col span={24}>
          <Card title="Willkommenstext" size="small">
            <Form.List name={['content', 'welcomeLetter', 'text']}>
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }) => (
                    <Form.Item
                      {...restField}
                      key={key}
                      name={name}
                      rules={[{ required: true, message: 'Bitte geben Sie einen Text ein' }]}
                    >
                      <TextArea 
                        rows={3} 
                        placeholder="Geben Sie hier einen Absatz des Willkommenstextes ein..."
                      />
                    </Form.Item>
                  ))}
                  <Form.Item>
                    <Button 
                      type="dashed" 
                      onClick={() => add()} 
                      block 
                      icon={<PlusOutlined />}
                    >
                      Absatz hinzufügen
                    </Button>
                  </Form.Item>
                </>
              )}
            </Form.List>
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: '16px' }}>
        <Col span={24}>
          <Card title="Unterschrift" size="small">
            <Form.Item
              name={['content', 'welcomeLetter', 'signature']}
              label="Unterschrift"
              rules={[{ required: true, message: 'Bitte geben Sie eine Unterschrift ein' }]}
            >
              <Input placeholder="z.B. Ihr Gastgeber-Team" />
            </Form.Item>
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: '16px' }}>
        <Col span={12}>
          <Card title="Wetterinformationen" size="small">
            <Form.Item
              name={['content', 'weather', 'current', 'temperature']}
              label="Aktuelle Temperatur (°C)"
            >
              <Input type="number" placeholder="22" />
            </Form.Item>

            <Form.Item
              name={['content', 'weather', 'current', 'condition']}
              label="Wetterbedingung"
            >
              <Input placeholder="z.B. Sonnig" />
            </Form.Item>

            <Form.Item
              name={['content', 'weather', 'current', 'feelsLike']}
              label="Gefühlte Temperatur (°C)"
            >
              <Input type="number" placeholder="25" />
            </Form.Item>
          </Card>
        </Col>

        <Col span={12}>
          <Card title="Zusätzliche Informationen" size="small">
            <Form.Item
              name={['content', 'welcomeLetter', 'specialNotes']}
              label="Besondere Hinweise"
            >
              <TextArea 
                rows={4} 
                placeholder="Besondere Hinweise für die Gäste..."
              />
            </Form.Item>

            <Form.Item
              name={['content', 'welcomeLetter', 'houseRules']}
              label="Hausregeln"
            >
              <TextArea 
                rows={3} 
                placeholder="Wichtige Hausregeln..."
              />
            </Form.Item>
          </Card>
        </Col>
      </Row>
    </div>
  );
}; 